<script>
import { getValue } from './utils';

export default {
    props: {
        // 选中的节点数据数组
        data: {
            type: Array
        }
    },
    inject: ['treeSelect'],
    data() {
        return {
            inputWidth: 0,
            keyword: ''
        };
    },
    watch: {
        keyword(val) {
            this.$parent.changeFilter(val);
        }
    },
    computed: {
        showClose() {
            return !this.$attrs.disabled && this.treeSelect.clearable && this.innerValue && this.innerValue.length;
        },
        innerValue() {
            return getValue(this.data, this.treeSelect.onlyLeaf, this.treeSelect.mergeValue, this.treeSelect.multiple, this.treeSelect.innerNodeConfig);
        },
        innerPlaceholder() {
            if (!this.data || !this.data.length) {
                return this.treeSelect.placeholder;
            }
            return '';
        }
    },
    methods: {
        deleteOneData(item) {
            return () => {
                this.treeSelect.$refs.treeWrapper.handleDeleteOne(item, this.treeSelect.checkbox);
            };
        },
        // 对原始tag数据进行处理
        formatTagData(data) {
            // checkbox并且mergeTag时，选择所有叶子节点后渲染父节点
            if (this.treeSelect.checkbox && this.treeSelect.mergeTag) {
                return data.filter(item => data.findIndex(v => v.id === item.parentId) === -1);
            }
            if (this.treeSelect.checkbox && this.treeSelect.onlyLeaf) {
                return data.filter(item => !item.children);
            }
            return data;
        },
        innerRenderTag(h, data = [], treeSelect) {
            if (this.treeSelect.renderTag && typeof this.treeSelect.renderTag === 'function') {
                return this.treeSelect.renderTag(h, data, treeSelect, this);
            } else {
                data = this.formatTagData(data || []);
                return (data || []).map(item => (
                    <el-tag
                        size="small"
                        key={item[treeSelect.innerNodeConfig.value]}
                        disable-transitions={true}
                        closable={!this.$attrs.disabled}
                        onClose={this.deleteOneData(item)}
                    >
                        {item[treeSelect.innerNodeConfig.label]}
                    </el-tag>
                ));
            }
        },
        clearKeyword() {
            this.keyword = '';
        },
        clearValue(e) {
            e.preventDefault();
            this.treeSelect.$refs.treeWrapper.clearValue();
        },
        Icon(h) {
            if (this.showClose) {
                return <i class="el-icon-circle-close close-icon" onClick={this.clearValue}></i>;
            }
            return <i class={`text-close pull-right ${this.treeSelect.popoverVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down'}`}></i>;
        }
    },
    render(h) {
        return (
            <div ref="tagWrapper" class={`tag-wrapper el-input el-input--${this.$attrs.size}`}>
                <span class="el-input__inner">
                    <span class="tag-wrapper__inner">
                        {this.innerRenderTag(h, this.data, this.treeSelect)}
                        {this.$attrs.disabled && this.innerValue && this.innerValue.length ? (
                            ''
                        ) : (
                            <input
                                ref="input"
                                v-model={this.keyword}
                                class="el-select__input"
                                placeholder={this.innerPlaceholder}
                                disabled={this.$attrs.disabled}
                            />
                        )}
                    </span>
                    <span class={`icon-wrapper ${this.showClose ? 'icon-wrapper__clearable' : ''}`}>{this.Icon(h)}</span>
                </span>
            </div>
        );
    }
};
</script>
